import React, { useState } from 'react';
import Tooltip from 'antd/es/tooltip';
import {FileCopyRounded} from "@mui/icons-material";

/**
 * Component to COPY TEXT WITHOUT NEEDING TO DISPLAY IT (Use antd Typography.Text with copyable instead for direct copy)
 * @param text
 * @param style
 * @param iconSize
 * @returns {JSX.Element}
 * @constructor
 */
const CopyText = ({ text, style, iconSize=18 }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyTextToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', ...style||{} }}
         onClick={copyTextToClipboard}
    >
      <Tooltip title={'Copy to Clipboard'}>
        <FileCopyRounded size={iconSize} style={{fontSize: iconSize, color: 'var(--color-primary)'}} />
      </Tooltip>
      {isCopied && <span style={{ marginLeft: '8px', color: '#4CAF50' }}>Copied!</span>}
    </div>
  );
};

export default CopyText;
